import React, { useEffect, useState } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import styles from "./ContactPage.module.css";
import axios from "axios";

// AUTOMATIC SWITCH: Uses localhost in development, real domain in production
const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "/api"
    : "https://dukamocoffee.com/api";

function ContactUsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // --- STATE MANAGEMENT ---
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [isSent, setIsSent] = useState(false); // Tracks if form is submitted
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Sends message to the admin email via backend
      await axios.post(`${API_BASE_URL}/contact/send`, formData);
      setIsSent(true); // Switch to Fancy Success View
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      console.error("Contact Form Error:", err);
      setError("Something went wrong. Please try again or call us directly.");
    } finally {
      setLoading(false);
    }
  };

  const faqs = [
    {
      q: "Q: What makes your coffee shop unique?",
      a: "A: Dukamo Coffee is unique for its ethically sourced coffee, expertly roasted in-house and brewed using various methods, including jebena, V60, and espresso. Our coffee shops blend cultural and modern outlooks.",
    },
    {
      q: "Q: Why is your macchiato not as hot as other places?",
      a: "A: We are at standard on par with international speciality cafes. If the beverage is too hot to hold then its too hot for consumption. When milk is steamed abouve 65-70 degrees it rapidly begins to break down. However is you still prefer it hot, feel free to let our servers know in advance to make it so.",
    },
    {
      q: "Q: Do you have dairy-free or alternative milk options?",
      a: "A: Sorry! we currently don't have alternative milk options, but soon we will.",
    },
    {
      q: "Q: Can I buy your coffee beans?",
      a: "A: Absolutely! We sell freshly roasted coffee beans in different roasts types for home brewing.",
    },
    {
      q: "Q: Do you offer food or pastries?",
      a: "A: Yes! We have a selection of freshly baked pastries and snacks that pair perfectly with our coffee.",
    },
    {
      q: "Q: Can I work or have meetings at your café?",
      a: "A: Yes you can, but sometimes our shops get busy and it gets a bit hard to work/ study alone.",
    },
    {
      q: "Q: Do you take reservations?",
      a: "A: We operate on a first-come, first-served basis, but we accommodate group bookings for special occasions.",
    },
    {
      q: "Q: Do you offer catering services?",
      a: "A: No, we currently don't provide catering services.",
    },
    {
      q: "Q: Can I place a custom coffee order?",
      a: "A: Yes, we can roast to your specifications and provide custom grind sizes based on your brewing method.",
    },
    {
      q: "Q: How fresh is your roasted coffee?",
      a: "A: Our coffee is roasted in small batches to ensure maximum freshness and flavor.",
    },
    {
      q: "Q: Do you provide grind options for home brewing?",
      a: "A: Yes! We can grind your coffee for Jebena, espresso, V60, or any other method.",
    },
    {
      q: "Q: Do you export coffee?",
      a: "A: Yes, we export roasted beans around the world.",
    },
    {
      q: "Q: Do you offer cupping or barista classes?",
      a: "A: Currently we only offer our classes for internal employees. However we will soon open the classes for public.",
    },
  ];

  return (
    <div className={styles.contactUsPage}>
      <Navbar />

      {/* HERO SECTION */}
      <section className={styles.contactHero}>
        <h1>Locations</h1>
        <p className={styles.subtitle}>Mafi City Mall, Bole Addis Ababa</p>
        <p className={styles.subtitle}>
          Nile Insurance Bldg, Mexico Addis Ababa
        </p>
        <p className={styles.subtitle}>
          Daye Bensa Building, Sumuda Gebriel, Hawassa
        </p>
      </section>

      {/* LOCATIONS GRID */}
      <section className={styles.locationsGrid}>
        <div className={styles.locationCard}>
          <div className={styles.mapEmbed}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.551710521639!2d38.78453437593258!3d8.995914690326466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b850400000001%3A0x6d90d797371192e2!2sMafi%20City%20Mall!5e0!3m2!1sen!2set!4v1704400000000!5m2!1sen!2set"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Mafi Location"
            ></iframe>
          </div>
          <div className={styles.locationDetails}>
            <h3>Mafi City Mall, Ground Floor</h3>
            <p>Addis Ababa</p>
            <p>Monday - Sunday 8:00AM - 9:00PM</p>
            <p>(+251)933443322</p>
          </div>
        </div>

        <div className={styles.locationCard}>
          <div className={styles.mapEmbed}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.5123456789!2d38.748123!3d9.012345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85f000000001%3A0x123456789abcdef!2sNile%20Insurance%20Building!5e0!3m2!1sen!2set!4v1704400000001"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Nile Insurance Location"
            ></iframe>
          </div>
          <div className={styles.locationDetails}>
            <h3>Nile Insurance Building</h3>
            <p>Ras Abebe Aregay St, Addis Ababa</p>
            <p>Monday - Sunday 8:00AM - 9:00PM</p>
          </div>
        </div>

        <div className={styles.locationCard}>
          <div className={styles.mapEmbed}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3958.4567890123!2d38.472123!3d7.051234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x17b1461234567890%3A0xabcdef123456789!2sDaye%20Bensa%20Building!5e0!3m2!1sen!2set!4v1704400000002"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Hawassa Location"
            ></iframe>
          </div>
          <div className={styles.locationDetails}>
            <h3>Daye Bensa Building Ground Floor</h3>
            <p>Hawassa</p>
            <p>Monday - Sunday 8:00AM - 8:00PM</p>
            <p>(+251)919046565</p>
          </div>
        </div>
      </section>

      <section className={styles.otherEnquiries}>
        <div className={styles.enquiryBlock}>
          <h3>For Wholesale service</h3>
          <p>(+251)92-422-22-00</p>
        </div>
        <div className={styles.enquiryBlock}>
          <h3>For Export</h3>
          <p>(+251)91-098-5454 or (+251)94-007-5265</p>
        </div>
        <div className={styles.enquiryBlock}>
          <h3>For Other Enquiries</h3>
          <p>Job Search: (+251)94-007-5265</p>
          <p>Complaints: (+251)91-098-5454</p>
        </div>
      </section>

      {/* --- FANCY FORM SECTION --- */}
      <section className={styles.formSection}>
        <h2>Send us a Message</h2>
        <div className={styles.formContainer}>
          {isSent ? (
            <div className={styles.successMessage}>
              <div className={styles.successIcon}>✓</div>
              <h3>Message Received</h3>
              <p>
                Thank you for reaching out to Dukamo Coffee. We have received
                your inquiry and will get back to you shortly.
              </p>
              <button
                onClick={() => setIsSent(false)}
                className={styles.resetBtn}
              >
                Send Another
              </button>
            </div>
          ) : (
            <form className={styles.contactForm} onSubmit={handleSubmit}>
              <div className={styles.formGrid}>
                <div className={styles.formGroup}>
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Full Name"
                  />
                </div>
                <div className={styles.formGroup}>
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="Email Address"
                  />
                </div>
              </div>
              <div className={styles.formGroup}>
                <label>Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  placeholder="Subject"
                />
              </div>
              <div className={styles.formGroup}>
                <label>Message</label>
                <textarea
                  name="message"
                  rows="6"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  placeholder="Your message..."
                ></textarea>
              </div>
              {error && <p className={styles.errorText}>{error}</p>}
              <button
                type="submit"
                className={styles.submitBtn}
                disabled={loading}
              >
                {loading ? "Sending..." : "Submit Message"}
              </button>
            </form>
          )}
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className={styles.faqSection}>
        <h2>FAQ's from Customers</h2>
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <div key={index} className={styles.faqItem}>
              <p className={styles.faqQuestion}>{faq.q}</p>
              <p className={styles.faqAnswer}>{faq.a}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ContactUsPage;
